import { render, staticRenderFns } from "./SecondaryLayout.vue?vue&type=template&id=918b0932&scoped=true&"
import script from "./SecondaryLayout.vue?vue&type=script&lang=js&"
export * from "./SecondaryLayout.vue?vue&type=script&lang=js&"
import style0 from "./SecondaryLayout.vue?vue&type=style&index=0&id=918b0932&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918b0932",
  null
  
)

export default component.exports